var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headPage"},[_c('div',{staticClass:"logo"},[_vm._v(" 海淀区科技类校外培训行业规范发展服务平台 ")])])
}]

export { render, staticRenderFns }